import type { JSONContent } from '@tiptap/react';

import { z } from 'zod';

import { activityIdSchema } from '../user/schemas';
import {
  jobPostApplyMode,
  jobPostExperienceLevels,
  jobPostLocationTypes,
  jobPostPriceTypes,
  jobPostPriceUnits,
  jobPostRegions,
  jobPostSources,
  jobPostStatuses,
} from './constants';

export const jobPostRegionSchema = z.enum(jobPostRegions);

export const jobPostLocationTypeSchema = z.enum(jobPostLocationTypes);

export const jobPostPriceTypeSchema = z.enum(jobPostPriceTypes);

export const jobPostPriceUnitSchema = z.enum(jobPostPriceUnits);

export const jobPostExperienceLevelSchema = z.enum(jobPostExperienceLevels);

export const jobPostSourceSchema = z.enum(jobPostSources);

export const jobPostStatusSchema = z.enum(jobPostStatuses);

export const jobPostApplyModeSchema = z.enum(jobPostApplyMode);

const jobPostBaseSchema = z.object({
  id: z.number(),
  source: jobPostSourceSchema,
  title: z.string(),
  description: z.json().pipe(z.custom<JSONContent>()),
  activityIds: z.array(activityIdSchema),
  region: jobPostRegionSchema.nullable(),
  locationType: jobPostLocationTypeSchema,
  price: z.number().nullable(),
  priceType: jobPostPriceTypeSchema,
  experienceLevel: jobPostExperienceLevelSchema.nullable(),
  startsAt: z.iso.datetime({ offset: true }).nullable(),
  endsAt: z.iso.datetime({ offset: true }).nullable(),
  closesAt: z.iso.datetime({ offset: true }).nullable(),
  clientName: z.string(),
  externalClientEmail: z.string().nullable(),
  externalLink: z.string().nullable(),
  applyMode: jobPostApplyModeSchema,
  logoUrl: z.string().nullable(),
  status: jobPostStatusSchema,
  userHasCreated: z.boolean(),
  userHasBookmarked: z.boolean(),
  userHasApplied: z.boolean(),
  createdAt: z.iso.datetime({ offset: true }),
  updatedAt: z.iso.datetime({ offset: true }),
});

const jobPostInternalMailSchema = z.object({
  ...jobPostBaseSchema.shape,
  applyMode: jobPostApplyModeSchema.extract(['InternalEmail']),
  externalLink: z.null(),
  externalClientEmail: z.null(),
});

const jobPostExternalEmailSchema = z.object({
  ...jobPostBaseSchema.shape,
  applyMode: jobPostApplyModeSchema.extract(['ExternalEmail']),
  externalClientEmail: z.string(),
});

const jobPostExternalUrlSchema = z.object({
  ...jobPostBaseSchema.shape,
  applyMode: jobPostApplyModeSchema.extract(['ExternalUrl']),
  externalLink: z.string(),
});

export const jobPostSchema = z.discriminatedUnion('applyMode', [
  jobPostInternalMailSchema,
  jobPostExternalEmailSchema,
  jobPostExternalUrlSchema,
]);
